import styled from "styled-components";
import { COLOR_WHITE } from "../../styles/globalStylesVariables";
import { tokens } from "@manifesthhqinc/ui-library";

export const LegalDisclaimerContainer = styled.div`
  color: ${tokens.color.neutral[700]};
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 20px;
  height: 100%;

  a {
    color: ${tokens.color.brand[600]};
  }
`;

export const CustomScrollbar = styled(LegalDisclaimerContainer)`
  max-height: 96px;
  background-color: ${tokens.color.neutral[200]};
  border-radius: 6px;
  width: 100%;
  overflow-y: scroll;

  padding: 9px 18px 7px 13px;

  &:hover {
    cursor: pointer;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 3px;
    max-height: 30px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${COLOR_WHITE};
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }
`;
